// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__23uSM","Logo":"Toolbar_Logo__3kxta","DesktopOnly":"Toolbar_DesktopOnly__-puY3"};